const { Core, Utils, Events } = Global;

customElements.define('cart-notification', class extends Core {
    elements = {
        modal: 'modal-container'
    }

    render() {
        this._reportEnabling();
        this._handleModal();
        this._muteDrawer();
        const dialog = this.querySelector('dialog');
        dialog?.setAttribute('aria-label', this.getAttribute('data-dialog-label'));
        dialog?.addEventListener('cancel', event => {
            event.preventDefault();
            this.$('modal').close();
        });
    }

    async _reportEnabling() {
        await customElements.whenDefined('cart-provider');
        this.pub(Events.CART_NOTIFICATIONS_ENABLING);
    }

    _handleAddToCart(update) {
        if (update.req !== 'cartAdd') return;
        queueMicrotask(() => {
            const region = this.querySelector('cart-live-region');
            const main = region?.querySelector('[data-added-variant-id]');
            const addedIds = (update.addedItems || []).map(item => String(item.variant_id || item.id));
            if (update.renderFailed || !main || !addedIds.includes(main.getAttribute('data-added-variant-id'))) {
                this._showFeedback(true);
            }
            this.$('modal').open();
        });
    }

    _handleError(error) {
        this._showFeedback(false, error?.confirmedFailure ? error.message : null);
        this.$('modal').open();
    }

    _showFeedback(added, message) {
        const template = this.querySelector('[data-cart-feedback]');
        const region = this.querySelector('cart-live-region');
        if (!template || !region) return;
        const content = template.content.cloneNode(true);
        content.querySelectorAll('[data-feedback-added]').forEach(element => element.hidden = !added);
        content.querySelectorAll('[data-feedback-unknown]').forEach(element => element.hidden = added);
        if (message) content.querySelector('p[data-feedback-unknown]').textContent = message;
        region.replaceChildren(content);
    }

    async _handleModal() {
        await customElements.whenDefined(this.elements.modal);
        this.sub(Events.CART_UPDATE, this._handleAddToCart, { global: true });
        this.sub(Events.CART_ERROR, this._handleError, { global: true });
    }

    async _muteDrawer() {
        await customElements.whenDefined('cart-drawer');
        this.pub(Events.CART_DRAWER_MUTE);
    }
});
